export const sitesWebMisc = {
  // NombreEditable.vue — inline-editable website name field
  ne: {
    aria: "Le nom de votre site web",
    placeholder: "Mon hébergement",
    hint: "Entrée pour enregistrer · Échap pour annuler",
  },

  // website/index.vue — website creation wizard
  website: {
    next: "Suivant",
  },

  // Notificaciones/index.vue — notifications timeline
  notif: {
    title: "Notifications",
    subtitle: "Tout ce qui s'est passé dans vos hébergements, par ordre chronologique.",
    // Filters
    filterAll: "Tout",
    filterBookings: "Réservations",
    filterCheckins: "Check-ins",
    filterServices: "Services",
    filterPayments: "Paiements",
    // Empty state
    emptyAll: "Aucune notification pour le moment",
    emptyFilter: "Aucune notification dans ce filtre",
    emptyBody:
      "Lorsqu'il se passe quelque chose avec vos réservations — une nouvelle, un check-in, un paiement — cela apparaîtra ici.",
    // Day separators
    noDate: "Sans date",
    today: "Aujourd'hui",
    yesterday: "Hier",
    // Event status (left column)
    stNueva: "Nouvelle",
    stActualizada: "Mise à jour",
    stCancelada: "Annulée",
    stRealizado: "Effectué",
    stSolicitado: "Demandé",
    stRecibida: "Reçue",
    stAprobada: "Approuvée",
    stRechazada: "Rejetée",
    stConfirmado: "Confirmé",
    stEnProceso: "Paiement en cours",
    stAviso: "Avis",
    // Event category (subtitle)
    catReserva: "réservation",
    catCheckin: "check-in",
    catServicio: "service",
    catSolicitud: "demande",
    catPago: "paiement",
    catPagoPendiente: "paiement en attente",
    catSistema: "système",
    // Descriptive event-type labels
    lbNuevaReserva: "Nouvelle réservation",
    lbReservaActualizada: "Réservation mise à jour",
    lbReservaCancelada: "Réservation annulée",
    lbCheckin: "Check-in",
    lbServicio: "Service",
    lbSolicitud: "Demande",
    lbSolicitudAprobada: "Demande approuvée",
    lbSolicitudRechazada: "Demande rejetée",
    lbPago: "Paiement",
    lbNotificacion: "Notification",
  },

  // Integrations/index.vue — integrations with external services
  integrations: {
    title: "Intégrations",
    subtitle: "Connectez des services externes pour simplifier la gestion",
    descPricelabs: "Optimisation dynamique des prix",
    descStripe: "Paiements par carte des clients",
    descWompi: "Paiements des clients en Colombie",
    connected: "Connecté",
    disconnected: "Non connecté",
  },
};
